<div
  class="gt-dashboard-ex collapsed"
  [class.gt-dashboard-ex--expanded]="expand"
  [ngStyle]="expand ? { height: '100%' } : { height: resolvedHeight }"
>
  <div class="gt-dashboard-ex-header">
    <h4 class="pull-left" title="{{ title }}">{{ title }}</h4>
    @if (showResize) {
<div class="btn pull-right" (click)="expandClose($event)">
      <i class="fa" [ngClass]="expand ? 'fa-times' : 'fa-expand'"></i>
    </div>
}
    <!--
      Legacy parity (`ui/app/components/dashboardExecutive/index.html`
      L721-779 + `gtDashboardContainerEx.selectChartType` in
      `ui/app/GlobalDirectives.js`). Cog icon opens a small popover
      offering the same chart-type icons the legacy build exposed:
      column / area / line for multi-series, pie / variablepie (donut)
      for single-series. Gated by `showChartTypeSwitcher` so executive
      admin dashboards stay unchanged.
    -->
    @if (showChartTypeSwitcher && chartCategory) {
<div class="btn pull-right chart-type-trigger"
        
         (click)="togglePopover(); $event.stopPropagation()"
         title="Chart Settings">
      <i class="fa fa-cog"></i>
      @if (popoverOpen) {
<div class="chart-type-popover gt-popover"
          
           (click)="$event.stopPropagation()">
        <div class="sub-header">Chart Type:</div>
        @if (chartCategory === 'multiSeries') {
<div class="chart-type">
          <a role="button"
             title="Column"
             [class.active]="currentChartType === 'column' || currentChartType === 'bar'"
             (click)="selectChartType('column')">
            <i class="fa fa-bar-chart"></i>
          </a>
          <a role="button"
             title="Area"
             [class.active]="currentChartType === 'area'"
             (click)="selectChartType('area')">
            <i class="fa fa-area-chart"></i>
          </a>
          <a role="button"
             title="Line"
             [class.active]="currentChartType === 'line' || currentChartType === 'spline'"
             (click)="selectChartType('line')">
            <i class="fa fa-line-chart"></i>
          </a>
        </div>
}
        @if (chartCategory === 'singleSeries') {
<div class="chart-type">
          <a role="button"
             title="Pie"
             [class.active]="currentChartType === 'pie'"
             (click)="selectChartType('pie')">
            <i class="fa fa-pie-chart"></i>
          </a>
          <a role="button"
             title="Donut"
             [class.active]="currentChartType === 'variablepie' || currentChartType === 'donut'"
             (click)="selectChartType('variablepie')">
            <i class="fa fa-pie-chart donut"></i>
          </a>
        </div>
}
      </div>
}
    </div>
}
    @if (showCollapseToggle && !expand) {
<div
      class="btn pull-right"
     
      (click)="toggleCollapse(!collapse)"
      title="Expand/Collapse Container"
    >
      <i
        class="fa"
        [ngClass]="{'fa-plus-square': collapse, 'fa-minus-square': !collapse}"
      ></i>
    </div>
}
    @for (action of actions; track $index) {
<div
     
      class="btn pull-right"
      (click)="action.onClick(component)"
      [title]="action.title"
    >
      <i class="fa" [ngClass]="action.icon"></i>
    </div>
}
  </div>
  <div class="gt-dashboard-ex-body">
    <ng-content></ng-content>
  </div>
  <div class="gt-dashboard-ex-footer"></div>
</div>
